import React from 'react';
import { motion } from 'framer-motion';
import { HeartPulseIcon, MessageSquareIcon, ClipboardListIcon, UserCheckIcon } from 'lucide-react';
export function HealthConsulting() {
  const services = [{
    title: 'Medication Therapy Management',
    desc: 'Comprehensive review of all your medications to ensure they are working effectively together.'
  }, {
    title: 'Chronic Disease Support',
    desc: 'Specialized guidance for managing conditions like diabetes, hypertension, and asthma.'
  }, {
    title: 'Wellness Planning',
    desc: 'Personalized nutrition and lifestyle recommendations tailored to your specific health goals.'
  }];
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="bg-white min-h-screen pb-20" data-id="element-392" data-mp="3rfhgbravvsgb">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 md:pt-20 mb-12 md:mb-16" data-id="element-393" data-mp="3nfgv9nta4j0a">
        <div className="inline-flex items-center gap-2 px-3 py-1 bg-clinical-blue/5 text-clinical-blue rounded-full text-[10px] font-bold uppercase tracking-widest mb-6" data-id="element-394" data-mp="3igdwum7t1b1a">
          Clinical Services
        </div>
        <h1 className="text-3xl md:text-5xl font-black text-slate-900 mb-6 uppercase tracking-tighter" data-id="element-395" data-mp="vonvwbjwljio">
          Health Consulting
        </h1>
        <p className="text-lg md:text-xl text-slate-600 max-w-3xl leading-relaxed" data-id="element-396" data-mp="ly1o33ifhxaj">
          Expert clinical advice tailored to you. Our pharmacists offer
          one-on-one consultations to help you achieve your health and wellness
          objectives.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-397" data-mp="10mfqxefuhlr3">
        <div className="grid lg:grid-cols-3 gap-8" data-id="element-398" data-mp="10o8xktqgk5z3">
          {services.map((s, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: i * 0.1
        }} className="bg-clean-grey p-8 rounded-2xl border border-slate-100 flex flex-col h-full" data-id="element-399" data-mp="15n3pqmabf6vv" data-mpi={i}>
              <div className="w-12 h-12 bg-white rounded-xl shadow-sm flex items-center justify-center text-clinical-blue mb-6" data-id="element-400" data-mp="1m56pvp9h11qk">
                {i === 0 ? <ClipboardListIcon className="w-6 h-6" data-id="element-401" data-mp="1i3cunwi1opxs" /> : i === 1 ? <HeartPulseIcon className="w-6 h-6" data-id="element-402" data-mp="1d639wu5lp2ga" /> : <UserCheckIcon className="w-6 h-6" data-id="element-403" data-mp="184dvd4j666ng" />}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-404" data-mp="135kinebpijoc">
                {s.title}
              </h3>
              <p className="text-slate-600 leading-relaxed flex-grow" data-id="element-405" data-mp="z5serex9d1pb">
                {s.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-20 bg-slate-900 rounded-3xl overflow-hidden flex flex-col md:flex-row" data-id="element-406" data-mp="2tj1jyuiru11r">
          <div className="p-8 md:p-16 md:w-1/2 text-white" data-id="element-407" data-mp="fb8y3z6f12cm">
            <MessageSquareIcon className="w-12 h-12 mb-8 text-clinical-blue" data-id="element-408" data-mp="faqwso4wbxxu" />
            <h2 className="text-3xl font-black mb-6 uppercase tracking-tight" data-id="element-409" data-mp="k8snnv8kd1jv">
              Speak with a Clinical Pharmacist
            </h2>
            <p className="text-slate-400 mb-10 leading-relaxed text-lg" data-id="element-410" data-mp="t2e3zj0dmqve">
              Our private consultation rooms provide a comfortable space to
              discuss your health concerns and medication needs in complete
              confidence.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-411" data-mp="1brf60fswjb6">
              <button className="bg-clinical-blue text-white font-black py-4 px-8 rounded-xl hover:bg-blue-700 transition-colors uppercase tracking-widest text-xs" data-id="element-412" data-mp="5cjrj2jyz4bo">
                Request Consultation
              </button>
              <button className="border-2 border-slate-700 text-white font-black py-4 px-8 rounded-xl hover:bg-slate-800 transition-colors uppercase tracking-widest text-xs" data-id="element-413" data-mp="1gr6ugzy8c6im">
                Learn More
              </button>
            </div>
          </div>
          <div className="md:w-1/2 bg-slate-800 min-h-[300px] relative" data-id="element-414" data-mp="1fb2qhpfhqwho">
            <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?q=80&w=1200&auto=format&fit=crop" alt="Pharmacist Consultation" className="absolute inset-0 w-full h-full object-cover opacity-60" data-id="element-415" data-mp="1fd5pgyymfzyj" />
          </div>
        </div>
      </div>
    </motion.div>;
}